import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';
import { GroupSelectComponent, GroupSelectOptionComponent } from '@rma/generic/ui/forms/group-select';
import { filter, take } from 'rxjs';
import { ImportantOptionType, ImportantOptions } from '../domain/important-options';
import { FindMyAgentStore } from '../orc-find-my-agent/find-my-agent.store';

@Component({
  selector: 'rma-important',
  imports: [
    AsyncPipe,
    GroupSelectComponent,
    GroupSelectOptionComponent,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    TranslocoModule,
  ],
  templateUrl: './important.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImportantComponent {
  public readonly options = ImportantOptions;

  protected store = inject(FindMyAgentStore);
  protected showOtherInputFlag = false;
  protected criterionControl = new FormControl<ImportantOptionType | null>(null, [Validators.required]);
  protected otherReasonControl = new FormControl<string | null>('');

  constructor() {
    this.criterionControl.valueChanges
      .pipe(filter(Boolean), take(1))
      .subscribe((importantCriterion) => this.store.patchState({ importantCriterion, nextStep: 'results' }));
  }

  protected showOtherInput() {
    this.showOtherInputFlag = true;
  }

  protected submit() {
    this.store.patchState({ otherImportantReason: this.otherReasonControl.value, nextStep: 'results' });
  }
}
